import imageCompression from 'browser-image-compression';

/**
 * Compress image before upload
 * @param {File} file - Image file to compress
 * @returns {Promise<File>} - Compressed image file
 */
export const compressImage = async (file) => {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    fileType: 'image/jpeg',
    initialQuality: 0.8
  };

  try {
    console.log(`Original file size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);
    const compressedFile = await imageCompression(file, options);
    console.log(`Compressed file size: ${(compressedFile.size / 1024 / 1024).toFixed(2)} MB`);
    return compressedFile;
  } catch (error) {
    console.error('Image compression failed:', error);
    // Return original file if compression fails
    return file;
  }
};

/**
 * Convert File to base64 string
 * @param {File} file - File to convert
 * @returns {Promise<string>} - Base64 string
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Process and compress multiple images
 * @param {FileList} files - Files to process
 * @returns {Promise<string[]>} - Array of base64 strings
 */
export const processImages = async (files) => {
  const fileArray = Array.from(files);
  const processedImages = [];

  for (const file of fileArray) {
    // Compress the image
    const compressedFile = await compressImage(file);
    
    // Convert to base64
    const base64 = await fileToBase64(compressedFile);
    processedImages.push(base64);
  }

  return processedImages;
};
